<template>
  <a-modal
    :title="isAdd ? '新建学校' : '修改学校'"
    :maskClosable="false"
    :width="640"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :cancelText="'取消'"
    :okText="'确定'"
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <a-form layout="horizontal" :form="form">
      <!-- 头像上传 -->
      <a-form-item label="Logo上传" :labelCol="{lg: {span: 7}}" :wrapperCol="{lg: {span: 13}}">
        <c-upload ossType="avatar" :isSingle="true" @uploadSuccess="uploadSuccess" :sourceFileList="sourceFileList"></c-upload>
      </a-form-item>

      <!-- 学校名字 -->
      <a-form-item label="学校名称" :labelCol="{lg: {span: 7}}" :wrapperCol="{lg: {span: 13}}">
        <a-input
          type="text"
          v-decorator="[
            'schoolName',
            {rules: [{ required: true, pattern: /^.{2,25}$/, message: '请输入长度为2~25位的学校名字' }], validateTrigger: 'change'}
          ]"
        />
      </a-form-item>

      <!-- 负责人 -->
      <a-form-item label="负责人" :labelCol="{lg: {span: 7}}" :wrapperCol="{lg: {span: 13}}">
        <a-select
          class="form-cell"
          placeholder="请选择"
          v-decorator="[
            'managerId',
            {rules: [{ required: true, message: '请选择负责人' }]}
          ]"
        >
          <a-select-option
            v-for="(item,index) in listManager"
            :key="index"
            :value="item.id"
          >{{item.nickname}}</a-select-option>
        </a-select>
      </a-form-item>

      <!-- 所属代理 -->
      <a-form-item label="所属代理" :labelCol="{lg: {span: 7}}" :wrapperCol="{lg: {span: 13}}" v-if="userInfo && userInfo.accRole.id != '1'">
        <a-select
          class="form-cell"
          placeholder="请选择"
          v-decorator="[
            'agentId',
            {rules: [{ required: true, message: '请选择负责人' }]}
          ]"
        >
          <a-select-option
            v-for="(item,index) in agencyList"
            :key="index"
            :value="item.id"
          >{{item.agentName}}</a-select-option>
        </a-select>
      </a-form-item>

      <!-- 地区 -->
      <a-form-item
        label="地区"
        class="form-oper"
        :labelCol="{lg: {span: 7}}"
        :wrapperCol="{lg: {span: 13}}"
      >
        <a-cascader
          :options="$store.state.common.address"
          placeholder="请选择"
          :fieldNames="{label: 'name',value: 'id',children: 'children' }"
          v-decorator="[
            'addressSelect',
            {rules: [{ required: true, message: '请选择地区' }]}
          ]"
        />
      </a-form-item>

      <!--学校介绍 -->
      <a-form-item label="学校介绍" :labelCol="{lg: {span: 7}}" :wrapperCol="{lg: {span: 13}}">
        <a-textarea
          placeholder="请输入"
          :autosize="{ minRows: 2, maxRows: 6 }"
          v-decorator="[
            'intro',
          ]"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import person from "../../api/person"

import CUpload from "../../components/CUpload"

import school from "../../api/school";

import agency from "../../api/agency"

import { analysisAddress } from "../../utils/address";

export default {
  name: "schoolFormModal",
  data() {
    return {
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      isAdd: true,
      schoolId: "",
      updateData: {},
      agencyList: [],
      avatarUrl: '',
      sourceFileList:[],
      listManager: [],//负责人列表
      userInfo: null, //user 信息
    };
  },
  components:{
    CUpload,
  },
  methods: {
    //头像上传成功之后回调
    uploadSuccess(url){
      this.avatarUrl = url;
    },

    //初始化，显示
    init(type, params) {
      this.visible = true;
      this.isAdd = type === "add" ? true : false;

      //初始化form表单数据
      if (params) {
        this.updateData = params;
        let formData = {};
        formData.schoolName = params.schoolName;
        formData.managerId = params.managerId;
        formData.agentId = params.agentId;
        this.sourceFileList = [params.imgUrl];
        formData.intro = params.intro;
        formData.addressSelect = [
          params.provinceId,
          params.cityId,
          params.districtId
        ];
        //修改入口，要记录当前学校的ID
        this.schoolId = params.id;
        //重置负责人列表（修改的之后，列表里面会多一条当前已绑定的负责人）
        this.getListManager(formData.managerId);
        setTimeout(() => {
          this.form.setFieldsValue(formData);
        }, 100);
      } else {
        this.form.resetFields();
        this.sourceFileList = [];
        this.getListManager()
      }
    },

    //隐藏
    handleCancel() {
      this.visible = false;
      this.$emit("closeForm");
    },

    //提交表单
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, value) => {
        console.log("输入的内容是：", value);
        //头像
        value.imgUrl = this.avatarUrl || this.sourceFileList[0];
        //校验通过 and 判断是否上传头像
        if (!err) {
          let tempValue = analysisAddress(value);
          if (this.isAdd) {
            this.addSchool(tempValue);
          } else {
            this.updateSchool(tempValue);
          }
        }
      });
    },

    //新增学校
    addSchool(value) {
      school.addSchool(value).then(res => {
        this.$message.success("新增成功");
        this.handleCancel();
        this.$emit("addSchool", res.data);
      });
    },

    //修改学校
    updateSchool(value) {
      school.updateSchool(this.schoolId, value).then(res => {
        this.$message.success("修改成功");
        Object.assign(this.updateData, value);
        this.$emit("updateSchool", res.data);
        this.handleCancel();
      });
    },
    
    //获取代理列表
    getAgencyList(){
      agency.getAgencyList().then(res => {
        console.log("当前的代理列表是", res.data.list);
        this.agencyList = res.data.list;
      });
    },

    //查询负责人
    getListManager(managerId) {
      let req = {
        roleId: "3",
      };
      if(managerId){
        req.managerId = managerId;
      }
      person.getListManager(req).then(res => {
        this.listManager = res.data;
      });
    }
  },
  mounted(){
    this.$store.dispatch('getUserInfo').then(res=>{
      this.userInfo = res;
      //角色为代理，没有查询代理列表的权限
      if(this.userInfo.accRole.id != '1'){  
        this.getAgencyList();
      }
    })
  }
};
</script>
<style lang="scss" scoped>
@import "src/config/var";
</style>